import type { BLEND_MODES } from 'pixi.js';

export function mapBlendMode(oldBlendMode: number): BLEND_MODES {
  if (oldBlendMode === 1) return 'add';
  if (oldBlendMode === 2) return 'multiply';
  if (oldBlendMode === 3) return 'screen';
  return 'normal';
}
